class ctxGridSetTableBodyHeightDirective {
    constructor($timeout) {
        this.$timeout=$timeout;
        this.restrict='A';
        this.require='^ctxGrid';
    }

    link(scope, element) {
        scope.$watch(()=> element.height(), ()=> {
                this.$timeout(()=> {
                        let tbody=element.find('tbody');
                        let thead=element.find('thead');
                        tbody.height(element.height() - thead.height());

                        if(tbody.get(0).scrollHeight > tbody.height()) {
                            //TODO: implement after adding fancy scroll that will work on all browsers...
                        }
                    }

                    , 0);
            }

        );
    }

    static directiveFactory($timeout) {
        return new ctxGridSetTableBodyHeightDirective($timeout);
    }
}

ctxGridSetTableBodyHeightDirective.directiveFactory.$inject=['$timeout'];

module.exports=ctxGridSetTableBodyHeightDirective.directiveFactory;


// WEBPACK FOOTER //
// ./src/shared/ctxGrid/ctxGridSetTableBodyHeight.directive.js